import type { ReactNode } from "react";
import { usePermission } from "./AccessProvider";

export function Can({
  children,
  fallback = null,
  permission,
}: {
  children: ReactNode;
  fallback?: ReactNode;
  permission: string;
}) {
  const allowed = usePermission(permission);
  return allowed ? children : fallback;
}
